// extracted by mini-css-extract-plugin
export default {"back_button_container":"BackButton_back_button_container__XF7Ff"};